export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-bold-4eaa61120377594a80149883089dcad2.svg";